/* eslint-disable import/order */
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { arjSettingsLoadingLimitsLegacyRedirectRoute } from '@jira/router-routes__advanced-roadmaps-settings-routes/src/arjSettingsLoadingLimitsLegacyRedirectRoute.tsx';
import { LazyArjSettingsLoadingLimits } from './ui/index.tsx';
import { redirectTo } from './ui/redirect.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const arjSettingsLoadingLimitsLegacyRedirectRouteEntry: Route = createEntry(
	arjSettingsLoadingLimitsLegacyRedirectRoute,

	() => ({
		group: 'software',
		// eslint-disable-next-line no-restricted-syntax
		component: redirectTo('/jira/plans/settings/loading-limits'),
		isRedirect: true,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
		},

		resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],
		forPaint: [LazyAtlassianNavigation, LazyArjSettingsLoadingLimits],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
